<template>
  <div v-if="bannerVisible" class="col-12">
    <div class="option warning-banner">
      <div class="option-value warning-option">
          <tickcrosswarning :value="bannerType" />  <!-- 3 = Warning -->
      </div>
      <div class="option-label">
        <div class="option-label">
        <span v-if="isHtml" v-html="bannerText" @click="handleClick"></span>
        <span v-else>{{ bannerText }}</span>
      </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue'
  import tickcrosswarning from '@/components/SPRTickCrossWarning.vue'

  export default Vue.extend({
  name: 'banner',
  components: {
    tickcrosswarning
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    bannerText: {
      type: String,
      required: false,
      default: ''
    },
    bannerType: {
      type: Number,
      required: false,
      default: 3 // 3 - Warning
    }
  },
  computed: {
    isHtml(): boolean {
        const htmlRegex = /<\/?[a-z][\s\S]*>/i;
        return htmlRegex.test(this.bannerText);
    },
    bannerVisible (): boolean {
      return !!this.bannerText && !this.disabled;
    },
  },
  methods: {
    handleClick(event: Event) {
      const target = event.target as HTMLElement;
      if (target.tagName === 'A' || target.tagName === 'BUTTON') {
        this.$emit('element-clicked', target);
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.warning-option {
    margin-left: 11px;
    margin-right: 11px;
  }

.warning-banner {
  margin-top: 6px;
  padding: 8px;
  display: flex;
  background: $brand-info-banner;
}

</style>